import L from "leaflet";

export const getClosestSegmentIndex = (
  latlngs: L.LatLng[], // Tous les points de la polyline (lat/lng)
  mouse: L.Point, // Position de la souris en pixel dans le container (e.containerPoint)
  map: L.Map, // La carte Leaflet
): number => {
  let closestSegmentIndex = -1;
  let minDistFound = Infinity;

  // On parcourt tous les segments : [p[i], p[si+1]]
  for (let i = 0; i < latlngs.length - 1; i++) {
    // Convertit les lat/lng du segment en coordonnées pixel
    const p1 = map.latLngToContainerPoint(latlngs[i]);
    const p2 = map.latLngToContainerPoint(latlngs[i + 1]);

    // vecteur du segment en pixel : p1 → p2
    const seg = p2.subtract(p1);

    /**
     * t = projection scalaire du vecteur souris-p1 sur le segment.
     * C’est la fraction de la longueur du segment où la projection tombe.
     * t peut être < 0 (avant p1) ou > 1 (après p2)
     */
    const t =
      ((mouse.x - p1.x) * seg.x + (mouse.y - p1.y) * seg.y) /
      (seg.x * seg.x + seg.y * seg.y);

    // On contraint t entre 0 et 1 → la projection reste *sur* le segment
    const tt = Math.min(1, Math.max(0, t));

    // Point projeté réel en pixel sur le segment
    const proj = new L.Point(p1.x + seg.x * tt, p1.y + seg.y * tt);

    // Distance souris → point projeté
    const dist = proj.distanceTo(mouse);

    // On garde le segment avec la distance la plus faible
    if (dist < minDistFound) {
      minDistFound = dist;
      closestSegmentIndex = i; // index du segment [i → i+1]
    }
  }

  return closestSegmentIndex;
};
